(function ($) {
  Drupal.behaviors.checkoutPlaceholder = {
    attach: function (context, settings) {
      $(document).ready(function(){
        if ($('.path-checkout .layout-checkout-form, form[class^="profile-customer-address-book-"], form[class^="profile-customer-shipping-address-book-"]').length) {
          $('.form-item:not(.form-type-checkbox) input, .form-item textarea, .form-item select:not(.country)').once().each(function(index, elem) {
            var eId = $(elem).attr("id");
            var label = null;

            if (eId && (label = $(this).parent().find("label[for="+eId+"]")).length == 1) {
              // If element is required
              if($(elem).hasClass('required')) { var required = 'required'; } else { var required = ''; }

              if ($(elem).is("select")) {
                // On select if option is not selected add fake placeholder with label value and check require/not_require for a *
                if($(elem)[0].selectedIndex === 0) {
                  $(elem).parent().prepend('<div class="placeholder-fake"><div class="'+ required +'"></div><span>' + $(label).html() + '</span></div>');
                }
              } else {
                // On input(not checkbox) and textarea if field is required and empty/full add/remove a *
                if($(elem).hasClass('required')) {
                  setTimeout(function () {
                    if ($(elem).val() == '') {
                      $(elem).parent().prepend('<div class="placeholder-fake" style="display: flex;"><div class="required"></div></div>');
                    } else {
                      $(elem).parent().prepend('<div class="placeholder-fake" style="display: none;"><div class="required"></div></div>');
                    }
                  }, 100);
                }
              }
              // Hide all labels instead of shipping options
              if(!eId?.includes("shipping-information-shipments")) {
                $(label).hide();
              }
            }

            // Check and hide a * on keyup, change,....
            $(this).on('keyup keydown keypress change paste', function() {
              var placeholderFake = $(this).parent().find('.placeholder-fake');
              if ($(this).val().length) { placeholderFake.hide(); } else { placeholderFake.show(); }
              if ($(this).hasClass('required')) {
                if ($(this).val().length) {
                  $(this).removeClass('error');
                }
              }
            });
          });
        }

        //move shipping methods to the top of the page
        $("#edit-shipping-information-shipments").prependTo($("#shipping-information-wrapper"));

        //move checkbox to the center when no description
        $('.layout-checkout-form .form-item').each(function() {
          let $formItem = $(this);
            if (!$formItem.find('.description').length) {
              $formItem.find('.label').addClass("moveCheckbox");
            }
        });
        //check if there is only one shipping method and style it
        let $shippingMethod = $('#edit-shipping-information-shipments-0-shipping-method-0');

        if ($shippingMethod.children().length === 1) {
          $shippingMethod.find('.form-radio').css({
            "background-color": "#f6f6f680",
            "border": "none"
          });
          $shippingMethod.find('.description').css("padding-left", "5px");
          $shippingMethod.find('.label').addClass("noPseudoClass");
        }
        // Stripe custom js
        if ($('.path-checkout div[id^="edit-onsite-payments-add-payment-method"]').length) {
          $('.stripe-form .form-text').once().each(function(index, elem) {
            var eId = $(elem);
            var label = eId.parent().find('label');
            var additionalText = '';

            // Add additional text to the fake placeholder
            if ($(elem).attr("id") == 'card-number-element') {
              var additionalText = '1234 1234 1234 1234';
            } else if ($(elem).attr("id") == 'expiration-element') {
              var additionalText = 'MM/YY';
            } else if ($(elem).attr("id") == 'security-code-element') {
              var additionalText = '';
            }
            $(elem).parent().prepend('<div class="placeholder-fake"><div class="required"></div><span>' + label.html() + '</span><span>' + additionalText + '</span></div>');

            // Check if browser support Mutation observer
            if (window.MutationObserver) {
              // Observer mutation
              var observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                  if ($(elem).hasClass('StripeElement--empty')) {
                    $(elem).parent().find(".placeholder-fake").show();
                  } else {
                    $(elem).parent().find(".placeholder-fake").hide();
                  }
                });
              });

              var config = { attributes: true };

              observer.observe($('#card-number-element')[0], config);
              observer.observe($('#expiration-element')[0], config);
              observer.observe($('#security-code-element')[0], config);
            } else {
              $('.stripe-form').addClass('non-observer');
            }
          });
        }
      });
    }
  };
})(jQuery);
